/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListPushHistoryResponseApiFrom } from '../../models/list-push-history-response-api-from';

export interface ApiV3ServiceListPushHistoryGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * deviceid of device to get history
 */
  deviceId?: string;
}

export function apiV3ServiceListPushHistoryGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceListPushHistoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceListPushHistoryGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('deviceId', params.deviceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListPushHistoryResponseApiFrom>>;
    })
  );
}

apiV3ServiceListPushHistoryGet.PATH = '/api/v3/service/ListPushHistory';
